import { Session } from "@supabase/supabase-js";
import { createContext, useEffect, useState } from "react";
import { supabaseClient } from "src/supabase/supabaseClient";

type SessionContextType = {
  session: Session | null;
  loading: boolean;
};

export const SessionContext = createContext<SessionContextType>({
  session: null,
  loading: true,
});

interface Props {
  children: React.ReactNode;
}

const SessionProvider = ({ children }: Props) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [session, setSession] = useState<Session | null>(null);

  useEffect(() => {
    // Get current session from supabase
    supabaseClient.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    // subscribe to auth state changes and update the session state
    const {
      data: { subscription },
    } = supabaseClient.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
    // clean up subscriptions on component unmount
    return () => subscription.unsubscribe();
  }, []);

  return (
    <SessionContext.Provider value={{ session, loading }}>
      {children}
    </SessionContext.Provider>
  );
};

export default SessionProvider;
